import _ from 'lodash';
import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import CustomerActions from '../../actions/CustomerActions';
import { RequestStates } from '../../stores/PaginatedStore';
import Customer from '../../models/Customer';
import Navbar from '../Navbar';
import config from '../../config/client';
import styles from './index.sass';
import banquetFooterLogo from '../Footer/images/banquet_footer_logo_3x.png';
import PasswordRevealPng from './images/password-reveal.png';
import PasswordRevealSvg from './images/password-reveal.svg';
import PasswordHidePng from './images/password-hide.png';
import PasswordHideSvg from './images/password-hide.svg';

const Modes = {
  EmailEntry: 'EmailEntry',
  PasswordEntry: 'PasswordEntry',
  NewAccountCreated: 'NewAccountCreated',
  PasswordReset: 'PasswordReset',
  PasswordResetRequested: 'PasswordResetRequested',
  SetPassword: 'SetPassword'
};
const PoweredBy = (
  <a className={styles.poweredBy} href={config.BanquetUrl}>
    <span>Powered By</span>
    <img src={banquetFooterLogo} alt="Powered By Banquet" />
  </a>
);

class AuthForm extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    getStore: React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  static propTypes = {
    mode: React.PropTypes.oneOf(_.values(Modes)),
    customer: React.PropTypes.instanceOf(Customer),
    requestStatus: React.PropTypes.string,
    onPasswordResetRequested: React.PropTypes.func,
    onSignIn: React.PropTypes.func,
    onSetPassword: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = _.extend({
      mode: Modes[props.mode] || Modes.EmailEntry,
      email: props.email || '',
      password: '',
      passwordResetRequested: false,
      passwordVisible: false
    }, this.getStateFromProps(props));
  }

  getStateFromProps(props) {
    return {
      error: props.error,
      loading: false,
      requestStatus: props.requestStatus
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    let error = nextProps.error;
    if(this.state.loading && this.props.requestStatus === RequestStates.Loading) {
      if(nextProps.requestStatus === RequestStates.Done) {
        switch(this.state.mode) {
          case Modes.EmailEntry:
            this.setState({mode: Modes.NewAccountCreated});
            break;
          case Modes.PasswordEntry:
            if(this.state.passwordResetRequested) {
              this.setState({mode: Modes.PasswordResetRequested, passwordResetRequested: false});
            } else {
              this.props.onSignIn && this.props.onSignIn();
            }
            break;
          case Modes.PasswordReset:
            this.setState({mode: Modes.PasswordResetRequested, passwordResetRequested: false});
            break;
          case Modes.SetPassword:
            this.props.onSetPassword && this.props.onSetPassword();
            break;
          default:
            break;
        }
      } else if(this.state.mode === Modes.EmailEntry && nextProps.requestStatus === RequestStates.Error && nextProps.error.name === 'ParametersInvalidError') {
        this.setState({mode: Modes.PasswordEntry});
        error = null;
      }
      if(nextProps.requestStatus === RequestStates.Done || nextProps.requestStatus === RequestStates.Error) {
        this.setState({loading: false});
      }
    }
    if(error !== this.state.error) {
      this.setState({error});
    }
  }

  handleOnChangeInput(e) {
    let key;
    switch(this.state.mode) {
      case Modes.EmailEntry:
      case Modes.PasswordReset:
        key = 'email';
        break;
      case Modes.PasswordEntry:
      case Modes.SetPassword:
        key = 'password';
        break;
      default:
        return;
    }
    this.setState({[key]: e.target.value});
  }

  handleOnKeyDown(e) {
    if(e.which === 13) {
      this.handleOnClickContinueButton();
    }
  }

  handleOnClickContinueButton(e) {
    switch(this.state.mode) {
      case Modes.EmailEntry:
        if(!validateEmail(this.state.email)) {return;}
        this.context.executeAction(CustomerActions.auth, {
          email: this.state.email,
          addIdentifierIfNotFound: true
        });
        break;
      case Modes.PasswordEntry:
        if(this.state.password.length < 1) {return;}
        this.context.executeAction(CustomerActions.auth, {
          email: this.state.email,
          password: this.state.password
        });
        break;
      case Modes.NewAccountCreated:
        this.props.onSignIn && this.props.onSignIn();
        break;
      case Modes.PasswordReset:
        this.context.executeAction(CustomerActions.resetPassword, {email: this.state.email});
        this.setState({passwordResetRequested: true});
        break;
      case Modes.PasswordResetRequested:
        this.props.onPasswordResetRequested && this.props.onPasswordResetRequested();
        break;
      case Modes.SetPassword:
        this.context.executeAction(CustomerActions.updatePassword, {password: this.state.password});
        break;
    }
    this.setState({loading: true});
  }

  handleOnClickEditButton(e) {
    this.setState({mode: Modes.EmailEntry, error: null});
  }

  handleOnClickForgotPassword(e) {
    this.context.executeAction(CustomerActions.resetPassword, {email: this.state.email});
    this.setState({loading: true, passwordResetRequested: true});
  }

  handleOnClickPasswordVisibleToggle(e) {
    this.setState({passwordVisible: !this.state.passwordVisible});
  }

  render() {
    let body, buttonContent, headerContent, subheaderContent, error;
    let { mode } = this.state;
    let continueButtonProps = {
      className: styles.continueButton,
      onClick: this.handleOnClickContinueButton.bind(this),
      disabled: this.state.loading
    };
    let inputProps = {
      className : styles.input,
      onChange: this.handleOnChangeInput.bind(this),
      onKeyDown: this.handleOnKeyDown.bind(this),
      autoFocus: true
    };
    if(this.state.error) {
      error = <p className={styles.error}>{this.state.error.user_message || this.state.message}</p>;
    }
    switch(mode) {
      case Modes.EmailEntry:
        headerContent = 'Enter your email address';
        subheaderContent = 'Enter your email address to sign in or create an account';
        continueButtonProps.disabled = continueButtonProps.disabled || !validateEmail(this.state.email);
        inputProps.placeholder = 'Enter email address';
        inputProps.value = this.state.email;
        inputProps.type = 'email';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Continue';
        body = (
          <div className={styles.body}>
            <input {...inputProps} />
            <button {...continueButtonProps}>{buttonContent}</button>
            <small className={styles.smallText}>By signing in you agree to our <a>Terms of Service</a></small>
            {PoweredBy}
          </div>
        );
        break;
      case Modes.PasswordEntry:
        headerContent = 'Welcome back!';
        subheaderContent = <span>Please enter your Banquet password for {this.state.email}<button onClick={this.handleOnClickEditButton.bind(this)}>(edit)</button></span>;
        continueButtonProps.disabled = continueButtonProps.disabled || !this.state.password;
        inputProps.placeholder = 'Enter password';
        inputProps.value = this.state.password;
        inputProps.type = this.state.passwordVisible ? 'text' : 'password';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Sign in';
        body = (
          <div className={styles.body}>
            <div className={styles.relativeWrapper}>
              <input {...inputProps} />
              <button className={styles.passwordVisibleButton} onClick={this.handleOnClickPasswordVisibleToggle.bind(this)}>
                <img src={this.state.passwordVisible ? PasswordHidePng : PasswordRevealPng} srcSet={this.state.passwordVisible ? PasswordHideSvg : PasswordRevealSvg} />
              </button>
            </div>
            <button {...continueButtonProps}>{buttonContent}</button>
            <small className={styles.smallText}><button onClick={this.handleOnClickForgotPassword.bind(this)}>Forgot password?</button></small>
            {PoweredBy}
          </div>
        );
        break;
      case Modes.NewAccountCreated:
        headerContent = 'Check your email';
        subheaderContent = 'Please check your inbox to finish creating your account.';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Okay';
        body = (
          <div className={styles.body}>
            <button {...continueButtonProps}>{buttonContent}</button>
          </div>
        );
        break;
      case Modes.PasswordReset:
        headerContent = 'Reset your password';
        subheaderContent = 'Enter your email address to reset your current password';
        inputProps.placeholder = 'Enter email address';
        inputProps.value = this.state.email;
        inputProps.type = 'email';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Continue';
        body = (
          <div className={styles.body}>
            <input {...inputProps} />
            <button {...continueButtonProps}>{buttonContent}</button>
            <small className={styles.smallText}></small>
            {PoweredBy}
          </div>
        );
        break;
      case Modes.PasswordResetRequested:
        headerContent = 'Check your email';
        subheaderContent = 'We sent you a link to reset your password.';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Okay';
        body = (
          <div className={styles.body}>
            <button {...continueButtonProps}>{buttonContent}</button>
          </div>
        );
        break;
      case Modes.SetPassword:
        headerContent = 'Set your new password';
        inputProps.placeholder = 'Enter new password';
        inputProps.value = this.state.password;
        inputProps.type = this.state.passwordVisible ? 'text' : 'password';
        buttonContent = this.state.loading ? <span className="loading-spinner--white" /> : 'Submit';
        body = (
          <div className={styles.body}>
            <div className={styles.relativeWrapper}>
              <input {...inputProps} />
              <button className={styles.passwordVisibleButton} onClick={this.handleOnClickPasswordVisibleToggle.bind(this)}>
                <img src={this.state.passwordVisible ? PasswordHidePng : PasswordRevealPng} srcSet={this.state.passwordVisible ? PasswordHideSvg : PasswordRevealSvg} />
              </button>
            </div>
            <button {...continueButtonProps}>{buttonContent}</button>
            <small className={styles.smallText}></small>
            {PoweredBy}
          </div>
        );
        break;
    }
    return (
      <div className={styles.authForm}>
        <h2 className={styles.header}>{headerContent}</h2>
        <p className={styles.subheader}>{subheaderContent}</p>
        {error}
        {body}
      </div>
    );
  }
}

export default AuthForm;

function validateEmail(email) {
  return email && (typeof email === 'string') && email.match(/.@./);
}



// WEBPACK FOOTER //
// banquet/components/AuthForm/index.js